import "preline/dist/preline.js" // ensure preline is loaded
import { Controller } from "@hotwired/stimulus";
import ls from 'localstorage-slim';

export default class extends Controller {
  static values = {
    identifier: String,
    idempotencyKey: { type: String, default: "" }, // this is an optional value. use it to have tabs reset across different instances of the same tab
    ttl: { type: Number, default: 3600 }, // how long to keep the tab data in seconds
  }

  connect() {
    HSTabs.autoInit() // ensure HSTabs is initialized
    this._hsTabs = HSTabs.getInstance(this.element)
    this._hsTabs.on("change", ({ current }) => this.store(current))
    this.restore()
  }

  disconnect() {
    this._hsTabs.off("change")
  }

  restore() {
    const tabData = this.tabData

    if (!tabData) return
    if (tabData.idempotencyKey !== this.idempotencyKeyValue) return

    const button = this.element.querySelector(`[data-hs-tab="${tabData.tab}"]`)
    if (!button) return

    HSTabs.open(button)
  }

  store(tab) {
    const payload = { idempotencyKey: this.idempotencyKeyValue, tab: tab }
    ls.set(this.storageKey, payload, { ttl: this.ttlValue })
  }

  get tabData() {
    return ls.get(this.storageKey) || null
  }

  get storageKey() {
    return `tabs:${this.identifierValue}`
  }
}
